import { DEVICE_TYPE, EXTERNAL_APPLY_CHANNEL } from '@/constants/common'
import { deviceDetector, getOmegaApplySource,getExternalChannel } from '../common'
import { querySet } from '../url'
const Omega = window.Omega

const device = deviceDetector() ? DEVICE_TYPE.MOBILE : DEVICE_TYPE.PC // 设备类型

export const ENV = {
  os: (() => {
    try {
      return Omega.selfReport.context.osType.toLowerCase()
    } catch (e) {
      return 'android'
    }
  })(),
  version: (() => {
    try {
      return Omega.selfReport.context.osVersion
    } catch (e) {
      return 'unknown'
    }
  })(),
}

const addPublicParamsToOmega = () => {
  const attrs = {
    country: 'MX',
    country_code: 'MX',
    page_source: querySet.page_source,
    activity_id: querySet.activity_id,
    channel_id: querySet.channel_id,
    resource_id: querySet.resource_id,
    ext: querySet.ext,
    pub_biz_line: 'fin',
    os: ENV.os,
    operating_system: ENV.os,
    version: ENV.version,
    app_version: ENV.version,
    from_source: querySet.from_source,
    apply_source: getOmegaApplySource(),
    device_type: device,
    apply_channel: EXTERNAL_APPLY_CHANNEL,
    is_preload: querySet.fromIframe,
    marketing_source:querySet.fromPage || '',
    external_channel:getExternalChannel()
  }
  Omega.setConfig({
    attrs,
  })
}

addPublicParamsToOmega()

if (window.adv) {
  const { getMediaData, isAdvChannel } = window.adv
  const marketPublicParams = isAdvChannel() ? getMediaData() : {} // 外投埋点渠道公参
  Omega?.setConfig({
    attrs: {
      ...marketPublicParams,
    }
  })
}

export const trackEvent = (eventId: string, attrs?: Record<string, any>) => {
  Omega?.trackEvent(eventId, '', attrs || {})
}

const omega = {
  trackEvent,
}

export default omega